import {create} from 'zustand';

export type ModalKey = 'profile' | 'balancePayment' | 'clientTariffs';

interface ModalPageStore {
  modalKey: ModalKey | null;
  setModalKey: (key: ModalKey) => void;
  hideModalContent: () => void;
}

export const useModalPageStore = create<ModalPageStore>((set) => ({
  modalKey: null,
  setModalKey: (key) => set({modalKey: key}),
  hideModalContent: () => set({modalKey: null}),
}));
